module.exports = __webpack_public_path__ + "img/RMR-computer.31fd30b8.png";